import React, {ReactElement} from "react";
import Topbar from "../../Topbar";
import AdminSidebar from "../../AdminSidebar";

export default function AdminPage({children}: { children: ReactElement }): ReactElement {
	return (
			<React.Fragment>
				<Topbar/>
				<AdminSidebar/>
				<div className="page">
					{children}
				</div>
			</React.Fragment>
	)
}